import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CategoryChangeWarningStatusService } from '../../../core/services/category-change-warning-status.service';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-category-change-warning-modal',
    templateUrl: './category-change-warning-modal.component.html',
    styleUrls: ['./category-change-warning-modal.component.scss'],
    imports: [TranslateModule, RouterLink, FormsModule],
})
export class CategoryChangeWarningModalComponent {
    confirmCallback: () => void;
    isDoNotShowModalAgain: boolean;
    ticketIds: number[] = [];

    constructor(
        private modalRef: BsModalRef,
        private categoryChangeWarningStatusService: CategoryChangeWarningStatusService,
    ) {}

    confirm(): void {
        if (this.isDoNotShowModalAgain) {
            this.categoryChangeWarningStatusService.saveModalDisplayStatus();
        }

        this.confirmCallback();
        this.modalRef.hide();
    }

    decline(): void {
        this.modalRef.hide();
    }
}
